module.exports = __webpack_public_path__ + "img/header-suche-icon-white.f6282e08.svg";